<template>
  <div class="bgimg">
    <div class="topleft">
    </div>
    <div class="middle">
      <h1 color="black">COMING SOON</h1>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  name: "ComingSoon",
  data(){
      return{

      }
  }
};
</script>

<style>
body,
html {
  height: 100%;
  margin: 0;
}

.bgimg {
  height: 100%;
  background-position: center;
  background-size: cover;
  position: relative;
  color: white;
  font-family: "Courier New", Courier, monospace;
  font-size: 25px;
}

.topleft {
  position: absolute;
  top: 0;
  left: 16px;
}

.bottomleft {
  position: absolute;
  bottom: 0;
  left: 16px;
}

.middle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: black;
}

hr {
  margin: auto;
  width: 40%;
}
</style>